export default "/images/verification-img.png?4d646fae9b5bb6a56a9d5c61a0710276";